/** Filled green pill — the primary action on light sections. */
export const primaryLink =
  'inline-flex min-h-12 items-center justify-center gap-3 rounded-full bg-green-700 px-7 py-3 text-sm font-medium text-white transition-colors hover:bg-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4'

/** Quiet underlined link — the secondary action on light sections. */
export const textLink =
  'inline-flex min-h-11 items-center gap-2 rounded-sm text-sm font-medium text-green-700 underline underline-offset-8 transition-colors hover:text-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700'
